import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function AllServicesIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1105_1778)'} = props;
	return (
		<SvgIcon className="ltr:-scale-100" width="11" height="20" viewBox="0 0 11 20" fill="none">
			<path
				d="M8.30386 1.09202L4.02386 5.37202L1.3972 7.98536C0.86552 8.51784 0.566895 9.23955 0.566895 9.99202C0.566895 10.7445 0.86552 11.4662 1.3972 11.9987L8.30386 18.9054C9.21053 19.812 10.7572 19.1587 10.7572 17.892V2.10536C10.7572 0.825355 9.21053 0.185355 8.30386 1.09202Z"
				fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1105_1778" x1="10.5397" y1="0.666994" x2="0.0591337" y2="0.956671"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
